import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import { Field, Form, reduxForm } from 'redux-form';
import Button from 'components/Button/Button';
import ModalInput from 'components/ModalInput/ModalInput';
import { PASSCODE_FORM } from 'constants/PasscodeModal';
import ReactSpinner from 'react16-spinjs';
import classes from '../InCallModal/InCallModal.module.scss';
import passcodeClasses from './PasscodeModal.module.scss';

const messages = defineMessages({
  placeholder: {
    id: 'components.passcodeModal.placeholder',
    defaultMessage: 'Type the passcode here.'
  }
});

const validate = (values) => {
  const errors = {};
  if (!values.passcode) {
    errors.passcode =
      values.numTries > 1 ? (
        <FormattedMessage
          id="components.passcodeModal.invalidPasscode"
          defaultMessage="Incorrect Passcode. Please try again."
        />
      ) : (
        <FormattedMessage id="components.passcodeModal.required" defaultMessage="A passcode is required." />
      );
  }
  return errors;
};

class PasscodeModal extends React.PureComponent {
  handleKeyDown = (evt) => {
    // to test: https://keycode.info/ (add input sources to your keyboard in the settings, switch by clicking the flag in the menu bar)
    if (evt.key === '#') {
      // This should capture all pound signs in theory (even IE 11); evt.key gives the resulting value of the key (or key combination) regardless of keyboard localization
      evt.preventDefault();
      this.props.submit();
    }
  };

  render() {
    const { handleSubmit, submitPasscode, pristine, invalid, submitting, submitSucceeded, intl } = this.props;

    return (
      <div className={`${classes.modal} ${passcodeClasses.container}`} data-testid="passcode-modal">
        <header>
          <h3>
            <FormattedMessage id="components.passcodeModal.title" defaultMessage="Passcode" />
          </h3>
        </header>
        <div className={passcodeClasses.modalContent} data-testid="passcode-greeting">
          <FormattedMessage
            id="components.passcodeModal.message"
            defaultMessage="This meeting is protected with a passcode."
          />
        </div>
        <div className={passcodeClasses.formContainer}>
          <Form onSubmit={handleSubmit(submitPasscode)} onKeyDown={this.handleKeyDown}>
            <Field
              autoComplete="new-password"
              autoFocus
              component={ModalInput}
              name="passcode"
              placeholder={intl.formatMessage(messages.placeholder)}
              type="password"
            />
            <Field data-testid="passcode-field" component="input" name="numTries" required={false} type="hidden" />
            <Button
              disabled={pristine || invalid || submitting || submitSucceeded}
              kind="primary"
              type="submit"
              dataAttrs={{
                'data-testid': 'enter-meeting-btn'
              }}
            >
              {!(submitting || submitSucceeded) ? (
                <span>
                  <FormattedMessage id="components.passcodeModal.buttonLabel" defaultMessage="# Enter meeting" />
                </span>
              ) : (
                <ReactSpinner
                  config={{
                    lines: 13,
                    length: 5,
                    width: 3,
                    radius: 5,
                    color: '#fff',
                    speed: 0.7
                  }}
                />
              )}
            </Button>
          </Form>
        </div>
      </div>
    );
  }
}

PasscodeModal.propTypes = {
  submit: PT.func,
  handleSubmit: PT.func,
  submitPasscode: PT.func.isRequired,
  pristine: PT.bool,
  invalid: PT.bool,
  submitting: PT.bool,
  submitSucceeded: PT.bool,
  intl: PT.object
};

export default reduxForm({
  form: PASSCODE_FORM,
  fields: ['passcode', 'numTries'],
  validate,
  getFormState: (state) => state.app.form
})(injectIntl(PasscodeModal));
